// Application dependencies

import { Authorisation } from '@/interfaces/authorisation/authorisation.interfaces';
import { ProductNameTitle } from '@/interfaces/authorisation/product.interfaces';

// User Enums ------------------------------------------------------------------------------------------------------------------------------

export enum UserFields {
  Authorisations = 'authorisations',
  CreatedAt = 'created_at',
  Email = 'email',
  Id = 'id',
  NonPortalProduct = 'non_portal_product',
  PortalProduct = 'portal_product',
  UpdatedAt = 'updated_at',
  User = 'user',
}

// User Interfaces -------------------------------------------------------------------------------------------------------------------------

export interface User {
  [UserFields.Authorisations]: Authorisation[] | null;
  [UserFields.CreatedAt]: string | null;
  [UserFields.Email]: string;
  [UserFields.Id]: number;
  [UserFields.UpdatedAt]: string | null;
}

export interface UserRedux {
  [UserFields.NonPortalProduct]: ProductNameTitle | null;
  [UserFields.PortalProduct]: ProductNameTitle | null;
  [UserFields.User]: User | null;
}
